/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserClaimsResponse } from './UserClaimsResponse';
import {
    UserClaimsResponseFromJSON,
    UserClaimsResponseFromJSONTyped,
    UserClaimsResponseToJSON,
    UserClaimsResponseToJSONTyped,
} from './UserClaimsResponse';

/**
 * 
 * @export
 * @interface UserAccessAndClaimsResponse
 */
export interface UserAccessAndClaimsResponse {
    /**
     * 
     * @type {string}
     * @memberof UserAccessAndClaimsResponse
     */
    applicationName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserAccessAndClaimsResponse
     */
    clientId?: string | null;
    /**
     * 
     * @type {UserClaimsResponse}
     * @memberof UserAccessAndClaimsResponse
     */
    userClaims?: UserClaimsResponse;
}

/**
 * Check if a given object implements the UserAccessAndClaimsResponse interface.
 */
export function instanceOfUserAccessAndClaimsResponse(value: object): value is UserAccessAndClaimsResponse {
    return true;
}

export function UserAccessAndClaimsResponseFromJSON(json: any): UserAccessAndClaimsResponse {
    return UserAccessAndClaimsResponseFromJSONTyped(json, false);
}

export function UserAccessAndClaimsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserAccessAndClaimsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'applicationName': json['applicationName'] === undefined ? undefined : json['applicationName'] === null ? null : json['applicationName'],
        'clientId': json['clientId'] === undefined ? undefined : json['clientId'] === null ? null : json['clientId'],
        'userClaims': json['userClaims'] == null ? undefined : UserClaimsResponseFromJSON(json['userClaims']),
    };
}

export function UserAccessAndClaimsResponseToJSON(json: any): UserAccessAndClaimsResponse {
    return UserAccessAndClaimsResponseToJSONTyped(json, false);
}

export function UserAccessAndClaimsResponseToJSONTyped(value?: UserAccessAndClaimsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'applicationName': value['applicationName'],
        'clientId': value['clientId'],
        'userClaims': UserClaimsResponseToJSON(value['userClaims']),
    };
}

